<template>
  <div class="list-box">
    <el-row type="flex" justify="space-between" align="middle">
      <strong class="text-dark pdc">草稿报告</strong>
      <span v-if="!hide">
        <el-button
          @click="OnTempReprotPass"
          size="mini"
          icon="el-icon-check"
          type="success"
          >确认通过</el-button
        >
        <el-button
          @click="OnTempReprotNoPass"
          size="mini"
          icon="el-icon-close"
          type="danger"
          >确认不通过</el-button
        >
      </span>
    </el-row>
    <el-table border :data="demolist" size="mini">
      <el-table-column prop="name" label="名称" min-width="200">
        <template slot-scope="scope">
          <strong>{{ scope.row.name }}</strong>
        </template>
      </el-table-column>
      <el-table-column prop="url" label="操作" width="200" align="center">
        <template slot-scope="scope">
          <el-button-group>
            <el-button
              v-if="scope.row.url.toUpperCase().endsWith('.PDF')"
              @click="onReviewReport(scope.row.url)"
              size="mini"
              icon="el-icon-view"
              >预览</el-button
            >
            <el-button
              @click="onDownloadReport(scope.row)"
              size="mini"
              type="primary"
              icon="el-icon-download"
              >下载</el-button
            >
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
    <el-row type="flex" justify="space-between" align="middle">
      <strong class="text-success pdc">正式报告</strong>
    </el-row>
    <el-table border :data="officiallist" size="mini">
      <el-table-column prop="name" label="名称" min-width="200">
        <template slot-scope="scope">
          <strong>{{ scope.row.name }}</strong>
        </template>
      </el-table-column>
      <el-table-column prop="url" label="操作" width="200" align="center">
        <template slot-scope="scope">
          <el-button-group>
            <el-button
              v-if="scope.row.url.toUpperCase().endsWith('.PDF')"
              @click="onReviewReport(scope.row.url)"
              size="mini"
              icon="el-icon-view"
              >预览</el-button
            >
            <el-button
              @click="onDownloadReport(scope.row)"
              size="mini"
              type="primary"
              icon="el-icon-download"
              >下载</el-button
            >
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { saveAs } from 'file-saver';
import gApi from '@/api/general-api'

export default {
  name: 'ReportList',
  props: {
    id: {
      type: String,
      default: () => null
    },
    demolist: {
      type: Array,
      default: () => []
    },
    officiallist: {
      type: Array,
      default: () => []
    },
    hidebtn: {
      type: Boolean,
      default: () => false
    }
  },
  data(){
    return {
      hide:false
    }
  },
  mounted(){
    this.hide = this.hidebtn
  },
  methods: {
    onReviewReport(url) {
      const a = document.createElement('a')
      a.href = url
      a.target = "_blank";
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    onDownloadReport({ url, name }) {
      if (url.toUpperCase().endsWith('.PDF')) {
        const oReq = new XMLHttpRequest();
        oReq.open("GET", url, true);
        oReq.responseType = "blob";
        oReq.onload = function () {
          var file = new Blob([oReq.response], {
            type: 'application/pdf'
          });

          saveAs(file, name.toLowerCase().includes(".pdf") ? name : name + ".pdf");
        }

        oReq.send();

      } else {
        const a = document.createElement('a');
        a.href = url;
        a.target = "_blank";
        a.download = url
        a.click();
      }
    },
    OnTempReprotPass() {
      gApi.TempReprotPass({
        ID: this.id,
        Data: JSON.stringify({})
      }).then(res => {
        if (!res.success) {
          return this.$message.error("操作失败：" + res.msg)
        } else {
          this.hide = true
          return this.$message.success("操作成功！")
          
        }
      })
    },
    OnTempReprotNoPass() {
      this.$prompt('请输入拒绝的原因', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /.+/,
        inputErrorMessage: '请输入拒绝的原因',
        closeOnClickModal: false,
        closeOnPressEscape: false
      }).then(({ value }) => {
        gApi.TempReprotNoPass({
          ID: this.id,
          Data: JSON.stringify({
            ErrorType: "草稿报告被拒绝",
            ErrorRemark: value
          })
        }).then(res => {
          if (!res.success) {
            return this.$message.error("操作失败：" + res.msg)
          } else {
            return this.$message.success("操作成功！")
          }
        })
      }).catch(() => { });
    }
  }
}
</script>

<style lang="scss">
.list-box {
  padding: 0px;
  .el-descriptions-item__cell {
    padding: 0px 5px !important;
  }
}
</style>